import { render, staticRenderFns } from "./CardHeaderFooterVarients.vue?vue&type=template&id=9ded8564"
import script from "./CardHeaderFooterVarients.vue?vue&type=script&lang=js"
export * from "./CardHeaderFooterVarients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports